import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAmaxPayBatchPaymentForm.DeletedPaymentDetailsPopupContent',
    {
        title: 'Batch Payment check',
        ok: 'ok',
        beforeTable: 'Following contact payment details were removed during the request creation process',
        afterTable:
            'In order to proceed with the request please check that there are no removed contact payment details used on the batch lines',
        tableHeaderContact: 'Contact payment details',
    }
);
